import { orderLinesListStyles } from "@insite/content-library/Components/OrderLinesList";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    productDetailLink: {
        css: css`
            span {
                color: #33333a !important;
                font-size: 16px;
                font-weight: 600;
                &:hover {
                    color: #006bc0 !important;
                }
            }
        `,
    },
};

orderLinesListStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #ffffff !important;
            }
            ul {
                background: #ffffff;
            }
        `,
    },
};

orderLinesListStyles.productInfoErpNumberGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        p {
            font-size: 14px;
            font-weight: 500;
            color: #006bc0;
            text-transform: capitalize;
        }
    `,
};

orderLinesListStyles.productInfoQtyOrderedHeadingAndText = {
    extendedStyles: {
        wrapper: {
            css: css`
                padding-right: 10px;
                width: auto;
            `,
        },
        heading: {
            variant: "legend",
            weight: "bold",
        },

        text: {
            css: css`
                text-align: center;
            `,
        },
    },
};

orderLinesListStyles.productInfoQtyShippedHeadingAndText = {
    extendedStyles: {
        wrapper: {
            css: css`
                padding-right: 10px;
                width: auto;
            `,
        },
        heading: {
            variant: "legend",
            weight: "bold",
        },

        text: {
            css: css`
                text-align: center;
            `,
        },
    },
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    wrapper: {
        css: css`
            padding-right: 10px;
            width: auto;
        `,
    },
    heading: {
        variant: "legend",
        weight: "bold",
    },

    text: {
        weight: "bold",
        css: css`
            text-align: center;
        `,
    },
};
